import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import Favicon from '../assets/images/favicon.png';
import Layout from '../components/Layout';
import Intro from '../components/Intro';
import ComponentLayout from '../components/common/ComponentLayout';
import StartRecording from '../components/RecordingButton';
import Pricing from '../components/PricingCards';
import ContactUs from '../components/ContactUs';
import Carousel from '../components/common/CarouselLayout';

import SectionTwoData from '../constants/SectionTwoData';
import FeaturesData from '../constants/FeaturesData';
import stepCarouselData from '../constants/StepCarousel';

import { pageTemplateProps } from '../types';

const defaultData = {
  pageUrl: 'Start using ScreenApp to record any online session',
  pageTitle: 'Start using ScreenApp to record any online session',
  metaTitle: 'Free Computer Audio Recorder Online: No Time Limit',
  metaDescription:
    'ScreenApp is a web-based, lightweight screen recorder software that lets you record your pc screen without additional plugins and downloads.',
  metakeywords: 'Best screen recorder, Free screen recorder',
  mainHeading: 'Start using ScreenApp to record any online session',
  mainDescription:
    'ScreenApp is a web-based, lightweight screen recorder software that lets you record your pc screen without additional plugins and downloads.',
  mainImage: 'Main-image.png',
  stepCarouselData,
  sectionTwoHeading: 'The only online screen recorder you will need',
  sectionTwoDescription:
    'With extensive recording and editing features, Screenapp supports any operating system.',
  stepsHeading: 'Steps',
  feedbackHeading: 'Feedback',
};

const Template = (props: pageTemplateProps) => {
  const {
    pageContext: {
      data: {
        pageUrl,
        pageTitle,
        metaTitle,
        metaDescription,
        metakeywords,
        mainHeading,
        mainDescription,
        mainImage,
        sectionTwoHeading,
        sectionTwoDescription,
        stepsHeading,
        feedbackHeading,
        stepCarouselData,
      } = defaultData,
    } = {},
  } = props;

  return (
    <Layout pageName={mainHeading}>
      <Helmet
        link={[{ rel: 'shortcut icon', type: 'image/png', href: `${Favicon}` }]}
      >
        <title>{pageTitle || pageUrl}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metakeywords} />

        {/* <!-- Google Tag Manager --> */}
            <script type="text/javascript">{`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-MNBKP2R');
      `}</script>
        {/* <!-- End Google Tag Manager --> */}
      </Helmet>

      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-MNBKP2R"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>
      {/* <!-- End Google Tag Manager (noscript) --> */}
      
      <Intro mainHeading={mainHeading} mainDescription={mainDescription} mainImage={mainImage} />
      <ComponentLayout
        sectionData={SectionTwoData}
        heading={sectionTwoHeading}
        description={sectionTwoDescription}
      />
      <StartRecording />
      <Carousel
        stepCarouselData={stepCarouselData}
        mainHeading={stepsHeading}
      />
      <ComponentLayout sectionData={FeaturesData} heading="Features" />
      <Pricing />
      <Carousel feedback mainHeading={feedbackHeading} />
      <ContactUs />
    </Layout>
  );
};

Template.propTypes = {
  pageContext: PropTypes.any,
  data: PropTypes.any,
};

export default Template;
